import React, {createContext, ReactNode, useState, Dispatch, SetStateAction} from 'react';

interface E4ImpactProjectsContextProps {
    filterUoas: any;
    uoas: any;
    baselineSubmissions: any;
    finalSubmissions: any;
    fields: any;
    breakdowns: any;
    projectsBreakdown: any;
    questionsChoices: any;
    baselineAccelerationProgramSubmissions: any;
    finalAccelerationProgramSubmissions: any;
    setFilterUoas: Dispatch<SetStateAction<any[]>>;
    setUoas: Dispatch<SetStateAction<any[]>>;
    setFields: Dispatch<SetStateAction<any[]>>;
    setBreakdowns: Dispatch<SetStateAction<any[]>>;
    setProjectsBreakdown: Dispatch<SetStateAction<any>>;
    setQuestionsChoices: Dispatch<SetStateAction<any[]>>;
    setBaselineSubmissions: Dispatch<SetStateAction<any[]>>;
    setFinalSubmissions: Dispatch<SetStateAction<any[]>>;
    setBaselineAccelerationProgramSubmissions: Dispatch<SetStateAction<any[]>>;
    setFinalAccelerationProgramSubmissions: Dispatch<SetStateAction<any[]>>;
}

type ContextProviderProps = {
    children?: ReactNode
}

export const E4ImpactProjectsContext = createContext<E4ImpactProjectsContextProps>({
    filterUoas: [],
    uoas: [],
    fields: [],
    breakdowns: [],
    projectsBreakdown: undefined,
    questionsChoices: [],
    baselineSubmissions: [],
    finalSubmissions: [],
    baselineAccelerationProgramSubmissions: [],
    finalAccelerationProgramSubmissions: [],
    setFilterUoas: () => {},
    setUoas: () => {},
    setFields: () => {},
    setBreakdowns: () => {},
    setProjectsBreakdown: () => {},
    setQuestionsChoices: () => {},
    setBaselineSubmissions: () => {},
    setFinalSubmissions: () => {},
    setBaselineAccelerationProgramSubmissions: () => {},
    setFinalAccelerationProgramSubmissions: () => {},
});

export const E4ImpactProjectsProvider = ({children}: ContextProviderProps) => {
    const [filterUoas, setFilterUoas] = useState<any[]>([]);
    const [uoas, setUoas] = useState<any[]>([]);
    const [fields, setFields] = useState<any[]>([]);
    const [breakdowns, setBreakdowns] = useState<any[]>([]);
    const [projectsBreakdown, setProjectsBreakdown] = useState<any>(undefined);
    const [questionsChoices, setQuestionsChoices] = useState<any[]>([]);
    const [baselineSubmissions, setBaselineSubmissions] = useState<any[]>([]);
    const [finalSubmissions, setFinalSubmissions] = useState<any[]>([]);
    const [baselineAccelerationProgramSubmissions, setBaselineAccelerationProgramSubmissions] = useState<any[]>([]);
    const [finalAccelerationProgramSubmissions, setFinalAccelerationProgramSubmissions] = useState<any[]>([]);
    
    const value = {
        filterUoas,
        uoas,
        fields,
        breakdowns,
        projectsBreakdown,
        questionsChoices,
        baselineSubmissions,
        finalSubmissions,
        baselineAccelerationProgramSubmissions,
        finalAccelerationProgramSubmissions,
        setFilterUoas,
        setUoas,
        setFields,
        setBreakdowns,
        setProjectsBreakdown,
        setQuestionsChoices,
        setBaselineSubmissions,
        setFinalSubmissions,
        setBaselineAccelerationProgramSubmissions,
        setFinalAccelerationProgramSubmissions
    }

    return (
        <E4ImpactProjectsContext.Provider value={value}>
            {children}
        </E4ImpactProjectsContext.Provider>
    )
}
